import { TODO } from '@b2b/types/core';
import uiRouter, { StateService } from '@uirouter/angularjs';
import angular, { IScope } from 'angular';

export const TemplatesReorderControllerModule = angular
  .module('acme.view.application.templates.reorder.controllers', [
    uiRouter,
    'acme.view.application.grids.events.templates.reorder.controllers',
  ])
  .controller('TemplatesReorderController', [
    '$scope',
    '$state',
    function TemplatesReorderController($scope: IScope & { templatesReorder: TODO }, $state: StateService) {
      $scope.templatesReorder = {
        model: [],
        searchLabel: 'Search templates',

        init: function () {
          $scope.$emit('Application::contentTitleChange', {
            title: 'Event Templates Display Order',
            buttonLeft: {
              label: 'Cancel',
              action: function () {
                $state.go('application.programs.templatesList');
              },
            },
            buttonRight: {
              label: 'Save Display Order',
              action: function () {
                $scope.templatesReorder.update();
              },
              items: [
                {
                  label: 'List Templates',
                  sref: 'application.programs.templatesList',
                },
              ],
            },
          });

          $scope.$on('$destroy', $scope.$watch('templatesReorder.searchQuery', this.onSearchQueryUpdate));
          $scope.$on(
            'GridsEventsTemplatesReorderController::Changed',
            this.onGridsEventsTemplatesReorderControllerChanged
          );
        },

        update: function () {
          $scope.$broadcast('GridsEventsTemplatesReorderController::Save');
          $scope.$on('GridsEventsTemplatesReorderController::Saved', this.onGridsEventsTemplatesReorderControllerSaved);
        },

        success: {
          init: function (response) {},
        },

        error: {
          init: function (response) {},
        },

        onGridsEventsTemplatesReorderControllerSaved: function (e, data) {},

        onGridsEventsTemplatesReorderControllerChanged: function (e, data) {
          const self = $scope.templatesReorder;
          self.hasChanges = data.changed;
          self.searchLabel = self.hasChanges ? 'Save changes to enable search' : 'Search templates';
        },

        onSearchQueryUpdate: function (n, o) {
          if (n !== o) {
            $scope.$broadcast('GridsEventsTemplatesReorderController::Search', { value: n });
          }
        },
      };

      $scope.templatesReorder.init();
    },
  ]).name;
